<turbo-frame [src]="turboFrameSrc" id="work-package-wikis-tab-content">
  <op-content-loader viewBox="0 0 100 100">
    <svg:rect x="0" y="0" width="100" height="25" rx="1" />

    <svg:rect x="0" y="28" width="100" height="8" rx="1" />
    <svg:rect x="0" y="39" width="100" height="8" rx="1" />
  </op-content-loader>
</turbo-frame>
